import { Product } from './product';
import { Filters } from '../helpers/filters';
import { Utils } from '../helpers/utils';

export class PcategoryTranslation {
  id: number;
  lang: 'en'|'pt'|'de'|'jp'|'cn'|'es'|'fr'|'ru'|'it';
  pcategory_id: number;
  name: string;
}
export class Pcategory {
  id: number;

  name: string;
  hidden: boolean;
  delivery: boolean;
  delivery_name: string;
  digital_menu: boolean;
  order_list: string|null; // default is alphabetically. we accept: 'alphabetically' | 'price_up' | 'price_down'

  display_order: string; // { delivery: integer, digital_menu: integer }

  created_at: string;
  updated_at: string;

  pcategory_translations: PcategoryTranslation[];

  schedule: string;

  // set by our front-end app
  products: Product[];
  user_hid: boolean;
  is_active: boolean;
  deliveryOrder: number;
  digitalMenuOrder: number;
  translatedName: string;
  parsedSchedule: {
    [day_of_week: string]: string[]
  };
  isOnSchedule: boolean;
  mixBlocked?: boolean;
  isPizza?: boolean;

  static setAdditionalData(pcategory: Pcategory, mode: 'delivery'|'on_site' = 'delivery') {
    pcategory.deliveryOrder = pcategory.display_order ? JSON.parse(pcategory.display_order)["delivery"] : 0;
    pcategory.digitalMenuOrder = pcategory.display_order ? JSON.parse(pcategory.display_order)["digital_menu"] : 0;
    pcategory.translatedName = pcategory.delivery_name || pcategory.name;
    pcategory.isPizza = (pcategory.name || '').indexOf('Pizzas ') == 0;
    if(pcategory.products) {
      Product.setArrayAdditionalData(pcategory.products, mode);
    }

    pcategory.isOnSchedule = true;
    if(pcategory.schedule){
      pcategory.parsedSchedule = JSON.parse(pcategory.schedule);
      pcategory.isOnSchedule = Pcategory.checkSchedule(pcategory) != 'closed';
    }

  }
  static setArrayAdditionalData(pcategories: Pcategory[], mode: 'delivery'|'on_site' = 'delivery') {
    for(let pcategory of pcategories) {
      Pcategory.setAdditionalData(pcategory, mode);
    }
  }

  static sortByDisplayOrder(pcategories: Pcategory[], mode: 'delivery'|'digital_menu'): Pcategory[] {
    Pcategory.setArrayAdditionalData(pcategories);

    let res = [];
    if(mode == 'delivery') {
      return Filters.orderAlphabetically(pcategories, 'deliveryOrder').reverse();
    } else {
      return Filters.orderAlphabetically(pcategories, 'digitalMenuOrder').reverse();
    }
  }
  static orderProducts(pcategory: Pcategory, products: Product[]): Product[] {
    switch(pcategory.order_list) {
    case("price_up"): {
      return Filters.orderAlphabetically(products, 'price');
    }
    case("price_down"): {
      return Filters.orderAlphabetically(products, 'price').reverse();
    }
    default: {
      return Filters.orderAlphabetically(products, 'name');
    }
    }
  }
  static availableLangs(pcategories: Pcategory[]): string[] {
    let res = [];
    for(let pcategory of pcategories) {
      if(pcategory.pcategory_translations && pcategory.pcategory_translations.length > 0) {
        for(let translation of pcategory.pcategory_translations) {
          Utils.pushIfNotExists(res, translation.lang);
        }
      }
    }

    return res;
  }
  // 'lang' is the language abreviation, like 'pt', 'en', 'es', ...
  static translate(pcategories: Pcategory[], lang: string) {
    if(pcategories == null)
      return;
    
    for(let pcategory of pcategories) {
      if(lang == null) {
        pcategory.translatedName = pcategory.delivery_name || pcategory.name;
      } else {
        for(let translation of pcategory.pcategory_translations) {
          if(lang == translation.lang) {
            pcategory.translatedName = translation.name;
          }
        }
      }
    }
  }
  
  static checkSchedule(pcategory: Pcategory): 'closed'|'open'|'closing'|'opening' {
    if(!pcategory.schedule)
      return 'open';

    if(!pcategory.parsedSchedule)
      Pcategory.setAdditionalData(pcategory);

    let aux = Utils.isOnSchedule(pcategory.parsedSchedule, 30, 30);

    return aux.status;
  }
}